import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./ConsultOption.css";

const ConsultOption = () => {
  return (
    <>
      <div className="container consult-option">
        <div className="row">
          <div className="col-md-12">
            <h1 className="headings text-center">
              <span>Flexible</span> Consultation Options
            </h1>
            <p className="text-center  consult-txt">
              Whether you prefer meeting face-to-face or connecting virtually,
              choose the consultation format that best suits your needs.
            </p>

            {/* <div className="row mt-5">
                        <div className="col-md-6">
                            <div className="consult-box">
                                <LazyLoadImage
            effect="blur"
 src={consultbox1} alt="" className='first-image'/>
                                <h4 className=' mt-4'>In-person or Virtual</h4>
                                <p className='cb1-txt mt-3'>Our consultations are available both in-person and virtually. Whether you prefer face-to-face discussions or the convenience of a virtual meeting, our team is equipped to deliver a top-quality experience tailored to your preference.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="consult-box2 consult-box">
                                <LazyLoadImage
            effect="blur"
 src={consultbox2} alt="" className='second-image'/>
                                <h4 className=' mt-5'>For Teams or Individuals</h4>
                                <p className='cb2-txt mt-3'>We cater to both individual consultations and group sessions. Whether you’re seeking a one-on-one session for personalized guidance or a collaborative workshop with your entire travel management team, we’re here to support you. Our tailored approach ensures that every stakeholder gains insights and strategies to enhance your corporate travel program.</p>
                            </div>
                        </div>
                    </div> */}

            <div className="row px-md-5 mt-md-5 mt-2">
              <div className="col-md-6">
                <div className="option-frame ">
                  <LazyLoadImage
                    src="https://blueberrywebsites.azureedge.net/bbt/images/consultbox1.png"
                    alt=""
                    className="first-image"
                    loading="lazy"
                  />
                  <h4 className=" mt-xxl-5 mt-md-3">In-person or Virtual</h4>
                  <p className="cb1-txt mt-lg-3">
                    Choose the mode that works best for you—meet with us in
                    person to get a personal touch on your travel planning or
                    schedule a virtual consultation to ensure more convenience
                    and flexibility.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="option-frame option-frame2 mt-4 mt-md-0">
                  <LazyLoadImage
                    src="https://blueberrywebsites.azureedge.net/bbt/images/consultbox2.png"
                    alt=""
                    className="second-image"
                    loading="lazy"
                  />
                  <h4 className=" mt-xxl-5 mt-md-3">
                    For Teams or Individuals
                  </h4>
                  <p className="cb2-txt mt-lg-3">
                    Whatever travel planning you seek, whether for group or
                    individual guidance, we provide personalized consultations
                    to meet the unique needs of both solo and team travelers.
                    Let us optimize your travel plans, your way!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsultOption;
